import { createAsyncAction, ActionType } from 'typesafe-actions';
import { showOverlay } from '../../overlays/actions';
import { OverlayId } from '../../../components/Overlays/types';
import { SuccessFetchActionPayload, FetchAction, DefaultErrorPayload } from '../../dataFetching/generators';
import { DataFetchingThunkAction } from '../../types';
import { log404ErrorAsWarning } from '../../../../common/apiAdapters/ErrorHandlers';
import { BoughtProductAPIResponse } from './types';

export const LastBoughtProductAction = createAsyncAction(
    '@BOUGHT_PRODUCT/FETCH_START',
    '@BOUGHT_PRODUCT/FETCH_SUCCESS',
    '@BOUGHT_PRODUCT/FETCH_FAILED'
)<FetchAction, SuccessFetchActionPayload<BoughtProductAPIResponse>, DefaultErrorPayload>();

export const fetchUserLastBoughtProduct = (brazeMessageId: string): DataFetchingThunkAction => async (
    dispatch,
    _,
    { apiService, logger }
) => {
    const identifier = brazeMessageId;
    dispatch(LastBoughtProductAction.request({ identifier }));
    try {
        const usersLastProduct = await apiService.shopApi.getLastBoughtProduct();
        if (usersLastProduct?.data?.sku) {
            dispatch(showOverlay(OverlayId.RATE_YOUR_PRODUCT));
            dispatch(LastBoughtProductAction.success({ data: usersLastProduct, identifier }));
        }
    } catch (err) {
        log404ErrorAsWarning(err, identifier, logger, 'fetchUserLastBoughtProduct');
        dispatch(LastBoughtProductAction.failure({ error: err, identifier }));
    }
};

export type BoughtProductActionType = ActionType<typeof LastBoughtProductAction>;
